import { useRef } from "react";
import {
  LeftContent,
  StyledVideo,
  UploadVideoContainer,
  UploadActions,
  UploadVideoButton,
  DeleteButton,
  ContainerWrapper,
  UploadVideoTitle,
  UploadVideoDesc,
  OpenGalleryButton,
} from "./ExtendVideo.styles";
import UploadAdButton from "../PlayboxAdCard/UploadAdButton";
import { ReactComponent as UploadCloudIcon } from "../../assets/icons/upload-cloud.svg";
import { selectSelectedCollection } from "../../store/slices/model/slice";
import { useSelector } from "react-redux";
import { MAX_VIDEO_SIZE } from "../../utils/constants";
import { toast } from "sonner";
import LottieIcon from "../../components/LottieIcon/LottieIcon";
import deleteAnimation from "../../assets/animations/trash.json";
// import TermsCheckboxComponent from "../TermsCheckboxComponent/TermsCheckboxComponent";

const ExtendVideo = ({
  generateContainer,
  uploadedVideo,
  setUploadedVideo,
  uploadedVideoRef,
  onOpenGalleryModal,
  galleryOnly = false,
  // showOutline,
  // agreeTos,
  // handleCheckboxClick,
  // shouldShake,
}) => {
  const fileInputRef = useRef();
  const collection = useSelector(selectSelectedCollection);

  if (!collection) {
    return null;
  }

  const handleFileChange = (e) => {
    const { files } = e.target;

    const file = files[0];

    if (
      file &&
      (file.type === "video/mp4" || file.type.startsWith("video/quicktime"))
    ) {
      if (file.size > MAX_VIDEO_SIZE) {
        toast.error("Video must be smaller than 30MB");
        return;
      }
      setUploadedVideo({ file, url: URL.createObjectURL(file) });
    } else {
      toast.error("Unsupported media type.");
    }
  };

  return (
    <ContainerWrapper>
      <LeftContent>
        <UploadVideoContainer>
          {uploadedVideo && (
            <DeleteButton
              onClick={() => {
                setUploadedVideo(null);
              }}
            >
              <LottieIcon
                animationData={deleteAnimation}
                trigger="hover"
                size={24}
              />
            </DeleteButton>
          )}
          {uploadedVideo ? (
            <StyledVideo src={uploadedVideo?.url} ref={uploadedVideoRef} />
          ) : (
            <>
              <UploadVideoButton
                onClick={() =>
                  galleryOnly
                    ? onOpenGalleryModal?.()
                    : fileInputRef.current?.click()
                }
              >
                {!galleryOnly && <UploadCloudIcon />}
                <UploadVideoTitle>
                  {galleryOnly ? "Open Gallery" : "Upload Video"}
                </UploadVideoTitle>
                <UploadVideoDesc>
                  {galleryOnly
                    ? "Select a video from your gallery to extend it."
                    : "The last frame of the video you upload will be used as the input."}
                </UploadVideoDesc>
              </UploadVideoButton>
              {!galleryOnly && (
                <OpenGalleryButton
                  type="button"
                  onClick={(event) => {
                    event.stopPropagation();
                    onOpenGalleryModal?.();
                  }}
                >
                  Open Gallery
                </OpenGalleryButton>
              )}
            </>
          )}

          {!galleryOnly && (
            <input
              type="file"
              ref={fileInputRef}
              accept="video/mp4,video/quicktime"
              onChange={handleFileChange}
              style={{ display: "none" }}
            />
          )}

          <UploadActions>
            <UploadAdButton />
          </UploadActions>
        </UploadVideoContainer>
        {generateContainer}
        {/* <TermsCheckboxComponent
          handleCheckboxClick={handleCheckboxClick}
          agreeTos={agreeTos}
          shouldShake={shouldShake}
          showOutline={showOutline}
          offMarginTop
          offHorizontalMargin
        /> */}
      </LeftContent>
    </ContainerWrapper>
  );
};

export default ExtendVideo;
